// Betting partners by country with logos and booking code availability
export const BETTING_SITES = {
  // Nigeria
  NG: [
    { name: "Bet9ja", code: "bet9ja", color: "#1A5F1A", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "BetKing", code: "betking", color: "#1E3A8A", textColor: "#fff" },
    { name: "MSport", code: "msport", color: "#D4145A", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
  ],
  // Ghana
  GH: [
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "Betika", code: "betika", color: "#FF9800", textColor: "#fff" },
    { name: "MSport", code: "msport", color: "#D4145A", textColor: "#fff" },
  ],
  // Kenya
  KE: [
    { name: "Betika", code: "betika", color: "#FF9800", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "Odibets", code: "odibets", color: "#E91E63", textColor: "#fff" },
  ],
  // South Africa
  ZA: [
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "Hollywoodbets", code: "hollywoodbets", color: "#800080", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "Betika", code: "betika", color: "#FF9800", textColor: "#fff" },
  ],
  // Tanzania
  TZ: [
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "Betika", code: "betika", color: "#FF9800", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "MSport", code: "msport", color: "#D4145A", textColor: "#fff" },
  ],
  // Uganda
  UG: [
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "Betika", code: "betika", color: "#FF9800", textColor: "#fff" },
    { name: "MSport", code: "msport", color: "#D4145A", textColor: "#fff" },
  ],
  // Cameroon
  CM: [
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "MSport", code: "msport", color: "#D4145A", textColor: "#fff" },
    { name: "Bet9ja", code: "bet9ja", color: "#1A5F1A", textColor: "#fff" },
  ],
  // Default (international)
  DEFAULT: [
    { name: "1xBet", code: "1xbet", color: "#1B5E9E", textColor: "#fff" },
    { name: "BetWay", code: "betway", color: "#00A651", textColor: "#fff" },
    { name: "SportyBet", code: "sportybet", color: "#FF6600", textColor: "#fff" },
    { name: "Bet365", code: "bet365", color: "#027B5B", textColor: "#FFDF1B" },
    { name: "BetKing", code: "betking", color: "#1E3A8A", textColor: "#fff" },
  ],
};

// All unique betting sites for footer
export const ALL_BETTING_SITES = [
  { name: "Bet9ja", code: "bet9ja", color: "#1A5F1A" },
  { name: "SportyBet", code: "sportybet", color: "#FF6600" },
  { name: "BetKing", code: "betking", color: "#1E3A8A" },
  { name: "1xBet", code: "1xbet", color: "#1B5E9E" },
  { name: "MSport", code: "msport", color: "#D4145A" },
  { name: "BetWay", code: "betway", color: "#00A651" },
  { name: "Betika", code: "betika", color: "#FF9800" },
  { name: "Bet365", code: "bet365", color: "#027B5B" },
  { name: "Hollywoodbets", code: "hollywoodbets", color: "#800080" },
  { name: "Odibets", code: "odibets", color: "#E91E63" },
];

export const getBettingSites = (countryCode) => {
  return BETTING_SITES[countryCode] || BETTING_SITES.DEFAULT;
};
